import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material';
import MuiAccordionSummary, { accordionSummaryClasses, AccordionSummaryProps } from '@mui/material/AccordionSummary';

export const AccordionSummaryStyled = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={<ExpandMoreIcon />} {...props} />
))(({ theme }) => ({
  borderRadius: 8,
  backgroundColor: theme.palette.grey[100],
  flexDirection: 'row-reverse',
  [`&.${accordionSummaryClasses.disabled}`]: {
    opacity: 1,
  },
}));
